import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    width: 100%;
    max-width: 1600px;
    margin: auto;
    margin-bottom: 5rem;

    @media (max-width: 768px) {
        flex-direction: column;
        margin-bottom: 3rem;
        padding: 0 1rem;
    }
`

export const ContentWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: 4rem;
    margin-top: 4rem;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 2rem;
        margin-top: 2rem;
    }
`

export const DataWrapper = styled.div`
    width: 50%;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        width: 100%;
    }
`

export const Description = styled.div`
    margin-bottom: 2rem;
`

export const DescriptionText = styled.p`
    white-space: pre-wrap;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: normal;
    color: #000;
    margin: 0;
    word-break: break-word;
    max-width: 100%;
    line-height: 1.5;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`

export const ContributorsContainer = styled.div``

export const Contributor = styled.div`
    display: flex;
    justify-content: space-between;
    min-height: 4rem;
    border-top: 1px solid #69707a;
`

export const ContributorText = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: normal;
    color: #000;
    margin: 0;
    margin-bottom: 1rem;

    @media (max-width: 768px) {
        font-size: 24px;
    }
`

export const ContributorRole = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    font-weight: normal;
    color: #000;
    max-width: 70%;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`

export const ContributorResponsible = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: #000;
    text-transform: uppercase;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`

export const ImageGalleryContainer = styled.div`
    width: 50%;

    @media (max-width: 768px) {
        width: 100%;
    }
`

export const ImageGallery = styled.div`
    height: min-content;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: flex-start;
`

export const ImageContainer = styled.div`
    flex: 1 1 calc(50% - 16px);
    height: 20rem;
    overflow: hidden;
    position: relative;

    @media (max-width: 768px) {
        flex: 1 1 100%;
        height: 15rem;
    }
`

export const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
`
